const resolution = {width: 540, height: 900};
const packFolder = "mobile_vertical/";
const pathFolder = "mobile_vertical/";

export const configGame_mobile_vertical = {
    packFolder: packFolder,
    pathFolder: pathFolder,
    type: "MobileVertical",

    Screen: {
        resolution: resolution,
        screen_ratio: resolution.width / resolution.height,
        loadscreen: {
            image: {name: "res/" + pathFolder + "loadscreen.jpg", rus: true},
            loadbar:{
                position: {x:0, y:861},
                image: "res/" + pathFolder + "loadbar.png"
            }
        }
    },

    MainScene: {
        maingameBackground: {name: "mainbackground.png"},
        uiBorder: {pos: {x: 1625, y: 802}},
        resultWin: {pos: {x: 36, y: 245}},
        resultForward: {pos: {x: 36, y: 245}},
        resultLose: {pos: {x: 36, y: 245}},
    },

    UiScene: {
        buttonMore: {pos: {x: 280, y: 544}},
        buttonStop: {pos: {x: 108, y: 544}},
        labelDealerPoints: { pos: {x: 384, y: 252}, font: {name: "font_points_mobile_vertical"}},
        labelPlayerPoints: { pos: {x: 384, y: 368}, font: {name: "font_points_mobile_vertical"}},
        labelScoreWin: { pos: {x: 223, y: 126}, font: {name: "font_score_mobile_vertical"}},
        labelScoreForward: { pos: {x: 349, y: 126}, font: {name: "font_score_mobile_vertical"}},
        labelScoreLose: { pos: {x: 503, y: 126}, font: {name: "font_score_mobile_vertical"}},
    },

    Cards: {
        GCardSizeX: 72,
        GCardSizeY: 113,
        GShirtsOffsetX: 0.5,
        GNewRoundEnd: {pos: {x: 422, y: 207}},
        GCardOffsetX: 35,
        GCardSlide: 1,
        GDealerStart: {pos: {x: 60, y: 207}},
        GPlayerStart: {pos: {x: 60, y: 336}},
    },

    Settings: {
        background: {pos: {x: 0, y: 52}},
        selectDeck: {pos: {x: 77, y: 59}},
        titleClassic: {pos: {x: 365, y: 458}},
        titlePinup: {pos: {x: 65, y: 458}},
        buttonOk: {pos: {x: 202, y: 624}},
        arrDeckInfo: [
            {x: 253, y: 220},
            {x: 19,  y: 220}
        ]
    },

    AccountChangedWindow: {
        background: {pos: {x: 0, y: 52}},
        buttonOk: {pos: {x: 202, y: 624}},
        labelTitle: {
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        }
    },

    Help: {
        background: {pos: {x: 0, y: 52}},
        backgroundTitle: {pos: {x: 81, y: 59}},
        buttonOk: {pos: {x: 202, y: 624}},
        labelTitle: {
            pos: {x: 218, y: 28},
            font: {
                fontFamily: "Arial",
                fontSize: 20,
                fill: 0xffffff,
                align: "centre"
            }
        },
        labelInfo: {
            pos: {x: 25, y: 88},
            font: {
                fontFamily: "Arial",
                fontSize: 12,
                fill: 0xffffff,
                align: "left"
            }
        },
        translateList: {
            name: {
                rus:'Игра «21»',
                eng:'Game «21»',
            },
            info: {
                rus:'Постарайтесь угадать, когда сумма карт будет равна 21!\n' +
                '\n' +
                'Как играть?\n' +
                '\n' +
                '    Сделайте ставку. Размер начальной ставки определяется до начала игры.\n' +
                '    Максимальная сумма ставки составляет ' + '#01' + ', минимальная - ' + '#02' + '.\n' +
                '    В начале игры сдаются две карты. Нажимая кнопку "Еще", берите по одной карте\n' +
                '           до тех пор, пока не приблизитесь к 21 очку\n' +
                '           (дополнительно можно взять не более трех карт).\n' +
                '           Считаете, что пора остановиться? Тогда кликайте по кнопке "Стоп".\n' +
                '    Если вы набрали 21 очко с помощью двух карт\n' +
                '           — вы побеждаете. В этом случае дилер не имеет права добирать.\n' +
                '    Если вы набрали 21 очко (или меньше, но количество больше, чем у дилера)\n' +
                '           — вы получаете выигрыш по ставке в соответствии с коэффициентом (x2).\n' +
                '    Если у дилера сумма очков меньше 17 — он обязан добрать ещё карты.\n' +
                '           Если сумма равна или больше 17 — остановиться.\n' +
                '    Если вы сыграли вничью, то ваша ставка возвращается в соответствии\n' +
                '           с коэффициентом (x0.9).\n' +
                '\n' +
                'Пять картинок приравнивается к 21 очку.\n' +
                '\n' +
                'Если у вас больше 21 очка, то вы перебрали и проигрываете.\n' +
                '\n' +
                'Исключением является случай, когда у вас на руках два туза (золотое очко),\n' +
                '   которое считается равным 21.\n' +
                '\n' +
                'Игра автоматически завершается Ничьей при счете 20-20.\n' +
                '\n' +
                'Максимальное количество карт на руках - 5.\n' +
                '\n' +
                'Старшинство карт: 6, 7, 8, 9, 10, J, Q, K, A\n' +
                '\n' +
                'Стоимость карт в соответствии со старшинством: 6, 7, 8, 9, 10, 2, 3, 4, 11',

                eng:'Try to guess when the total value of cards gets to 21!\n' +
                '\n' +
                'How to play\n' +
                '\n' +
                '    Place a bet. The initial bet is determined before the start of a game.\n' +
                '    The maximum bet is ' + '#01' + ', the minimum bet is ' + '#02' + '.\n' +
                '    At the start of a game, the player (you) receive two cards and the dealer receive one card. \n' +
                '       You then take one card at a time by clicking "More" until\n' +
                '       the total value of the hand is close to 21 \n' +
                '       (you can take up to 3 additional cards).When you think it\'s time to stop, click "Stop".\n' +
                '    If you score 21 points with the first two cards, you win.\n' +
                '       - In this case the dealer cannot take additional cards.\n' +
                '    If you score 21 points (or less than 21 but more than the dealer),\n' +
                '       - your bet will be paid out at odds of x2.\n' +
                '    If the dealer scores less than 17 points, they must take additional cards.\n' +
                '       If the dealer scores 17 or more points, they must stand.\n' +
                '    If there is a draw ("push"), your bet will be paid out at odds of x0.9.\n' +
                '\n' +
                'Five cards with images equates to 21 points.\n' +
                '\n' +
                'If you score more than 21 points, you go bust and lose.\n' +
                '\n' +
                'An exception to this rule is when you hold two Aces ("Golden Point"), which scores you 21.\n' +
                '\n' +
                'If score 20-20 than game ends in a draw.\n' +
                '\n' +
                'The maximum number of cards on hand is 5.\n' +
                '\n' +
                'Cards ranking: 6, 7, 8, 9, 10, J, Q, K, A\n' +
                '\n' +
                'Value of cards according to their rank: 6, 7, 8, 9, 10, 2, 3, 4, 11\n'
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/mobile_vertical/game.es6
// module id = 45
// module chunks = 0